import { CircleStop } from 'lucide-react';

import Block from './Block';

import { AGENT_MESSAGE_STATUSES } from '@/app/agentConversation/_enums';
import { blocksToRender } from '@/app/agentConversation/_helpers';

import { Error } from '@/app/ui/error';
import { Spinner } from '@/app/ui/spinner';

// What the status line says while a reply is written.
const runningLabel = (visibleCount, heldCount) => {
  if (heldCount) return `Writing… ${heldCount} ${heldCount === 1 ? 'visual' : 'visuals'} to follow`;
  return visibleCount ? 'Working…' : 'Thinking…';
};

/**
 * A reply, block by block. While it streams, a spinner shows where the next
 * part will appear, and what it showed waits below until the text is done
 * (see `blocksToRender`). `isAskPending` is true only for the latest reply,
 * while nothing has been said after it — the one ask card that can still be
 * answered.
 */
const AssistantMessage = ({ blocks, status, error, isRunning = false, isAskPending = false, onAnswer }) => {
  const { visible, heldCount } = blocksToRender(blocks, isRunning);

  return (
    <div className="space-y-1" data-testid="agent-assistant-message">
      {visible.map((block, index) => (
        // A reply's blocks have no identity of their own; their place is it.
        // eslint-disable-next-line react/no-array-index-key
        <Block key={`${block.type}-${index}`} block={block} isPending={isAskPending} onAnswer={onAnswer} />
      ))}
      {isRunning && (
        <div className="text-muted-foreground flex h-6 items-center gap-2 text-xs" data-testid="agent-thinking">
          <Spinner />
          {runningLabel(visible.length, heldCount)}
        </div>
      )}
      {status === AGENT_MESSAGE_STATUSES.STOPPED && (
        <div className="text-muted-foreground flex items-center gap-1.5 text-xs" data-testid="agent-stopped">
          <CircleStop className="size-3.5" />
          Stopped
        </div>
      )}
      {(status === AGENT_MESSAGE_STATUSES.FAILED || error) && <Error message={error || 'Something went wrong. Try again.'} dataTestId="agent-failed" />}
    </div>
  );
};

export default AssistantMessage;
